import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["layout"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { StyledGridLayout } from './GridLayout.styles';
var LAYOUT_TEMPLATES = {
  fluid12: 'repeat(12, minmax(0, 1fr))',
  fixed12: 'repeat(auto-fit, 88px)',
  auto: 'repeat(auto-fit, minmax(0, 1fr))'
};

/**
 * Grid layout is a specialized grid container used to quickly create a grid using common grid
 * configurations. Common configurations usually include definitions for gaps and column templates.
 *
 * This component extends the `Grid` component which
 * has limited support for IE11. See the `Grid`
 * component for more details.
 *
 * @extends Grid
 * @since 8.22.0
 */
export var GridLayout = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var layout = _ref.layout,
    rest = _objectWithoutProperties(_ref, _excluded);
  var addProps = {};
  var template = LAYOUT_TEMPLATES[layout];
  if (template) {
    addProps.gridTemplateColumns = template;
  }
  return /*#__PURE__*/React.createElement(StyledGridLayout, _extends({
    ref: forwardedRef
  }, addProps, rest));
});
GridLayout.displayName = 'GridLayout';
GridLayout.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The `display` prop from `Grid`.
   */
  display: PropTypes.oneOf(['grid', 'inline-grid']),
  /**
   * The `gap` prop from `Grid`.
   */
  gap: PropTypes.string,
  /**
   * The `justifyContent` prop from `Grid`.
   */
  justifyContent: PropTypes.oneOf(['start', 'end', 'center', 'stretch', 'space-around', 'space-between', 'space-evenly']),
  /**
   * A pre-defined grid template configuration.
   *
   * Note: `fixed12` and `auto` layouts use `auto-fit` which is not supported by IE11.
   * If you need to support IE11, use `fluid12` or specify your own `gridTemplateColumns` using
   * the `Grid` component.
   */
  layout: PropTypes.oneOf(['fluid12', 'fixed12', 'auto'])
} : {};
GridLayout.defaultProps = {
  display: 'grid',
  gap: 'sm',
  justifyContent: 'center',
  layout: 'fluid12'
};